module.exports = __webpack_public_path__ + "static/media/workingmemory-words-4.9b635793.mp3";